import axios from 'axios';
import { setAlert } from './alert';
import {
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    USER_LOADED,
    AUTH_ERROR,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    CHANGE_PASSWORD,
    CAPTCHA_FAIL
} from './types';

import { clearCharacter } from './character';
import setAuthToken from '../utils/setAuthToken';

// Load user from jwt token
export const loadUser = () => async dispatch => {
    if(localStorage.token) {
        setAuthToken(localStorage.token);
    }

    try {
        const res = await axios.get('/api/auth');

        dispatch({
            type: USER_LOADED,
            payload: res.data
        });

        
    } catch (err) {
        dispatch({
            type: AUTH_ERROR
        });
    }
}

// Load user from reset token
export const resetFindUser = (token) => async dispatch => {

    try {

        const res = await axios.get(`/api/auth/reset/${token}`);

        dispatch({
            type: USER_LOADED,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: AUTH_ERROR
        });
    }
}

// Register New User
export const register = ({ email, username, password, captchaToken }) => async dispatch => {

    const body = {email, username, password, captchaToken };

    try {
        const res = await axios.post('/api/users', body);

        dispatch({
            type: REGISTER_SUCCESS,
            payload: res.data
        });

        dispatch(loadUser());
        
    } catch (err) {
        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: REGISTER_FAIL
        });
    }
}

// Log in User
export const login = (email, password) => async dispatch => {
    const body = {email, password}

    try {
        const res = await axios.post('/api/auth', body);

        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        });

        dispatch(loadUser());
    } catch (err) {
        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: LOGIN_FAIL
        });
    }
}

// Logout / Clear profile
export const logout = () => dispatch => {
    localStorage.clear();
    dispatch({ type: LOGOUT });
}

// Change password
export const changePassword = (token, password, navigate) => async dispatch => {

    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = {token, password}

    try {

        const res = await axios.post('/api/auth/changePassword', body, config);

        dispatch({
            type: CHANGE_PASSWORD,
            payload: res.data
        });

        localStorage.clear();
        dispatch({ type: LOGOUT });

        navigate('/dashboard');

        dispatch(setAlert('Password Successfully Updated','success', 2000));
        
    } catch (err) {
        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: AUTH_ERROR
        });
    }

}